import { useCallback } from 'preact/hooks';
import { listeners } from '@/index';
import { triggerEvent } from '@/utils';
import { useFormProps, useConfigStore } from '../stores/ConfigStore';
import useFeedback from './useFeedback';

export default function useJsEvents() {
	const { formKey, triggerMethod } = useFormProps();
	const { properties } = useConfigStore();
	const feedback = useFeedback({
		addExtraData: true,
		excludeScreenShotDom: true
	});
	const event = useCallback(
		(e, props = {}) => {
			const eventProps = {
				event: e,
				key: formKey,
				formName: properties.name,
				triggerMethod: triggerMethod,
				...(['feedback_sent', 'next', 'question_answered'].indexOf(e) > -1 && {
					feedback
				}),
				...props
			};

			triggerEvent(eventProps);
			listeners[e]?.forEach(fn => {
				try {
					fn(eventProps);
				} catch (e) {}
			});
		},
		[formKey, triggerMethod, properties, feedback]
	);

	return event;
}
